export default __webpack_public_path__ + "static/media/Innovate UK Logo - Full Colour.22147c76.png";